import { dmApi } from "../dmApi";
import { getAuthorizationHeader } from "../../helpers/RtkQueryUtils";
import { handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";
const PrescriptionApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        getPrescription: build.query({
            query: ({ prescriptionType }) => ({
                url: `/prescriptions/details?prescriptionType=${prescriptionType}`,
                headers: getAuthorizationHeader(),
                method: "POST",
            }),
            providesTags:['getPrescriptionApi']
        }),
        updatePrescription: build.mutation({
            query: ({ body }) => ({
                url: `/prescriptions/savePrescription`,
                headers: getAuthorizationHeader(),
                method: "PUT",
                body: body
            }),
        }),
        analyzePrescription: build.mutation({
            query: ({ ItemID }) => ({
                url: `/prescriptions/analyzePrescription`,
                headers: getAuthorizationHeader(),
                method: "POST",
                body: { ItemID }
            }),
        }),

    }),
});

export const {
    useGetPrescriptionQuery,
    useUpdatePrescriptionMutation,
    useAnalyzePrescriptionMutation
} = PrescriptionApi;
